import { CLEAR_WRITE, SELECT_NEWS, WRITE_NEWS } from '../actions/types';

const INITIAL_STATE = {};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_NEWS:
      return action.payload;
    case WRITE_NEWS:
      return { ...state, [action.target]: action.payload };
    case CLEAR_WRITE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
